import React from "react";
import PropTypes from "prop-types";
import RulesGame from "../../components/RulesGame";
import BaseButton from "../../components/BaseButton";
import BaseSingleCheckbox from "../../components/BaseSingleCheckbox";
import useController from "./controller";
import ExitModal from "../../modals/ExitModal";
import Ellipses from "../../components/Ellipses";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import { useTranslation } from "react-i18next";
import WrapperPage from "../../components/WrapperPage";
import "./style.scss";

export default function RulesPage({ typeRule }) {
  const { isCurrentUserMale } = useCurrentUserData();
  const { isRulesAccepted, onCheckRules, continueGame } = useController();
  RulesPage.propTypes = {
    typeRule: PropTypes.string,
  };
  const { t } = useTranslation();
  return (
    <div className="rules-page-wrapper centering-page">
      <Ellipses className="rules-page-wrapper-ellipses" countEllipses={2} />
      <ExitModal />
      <WrapperPage backBtn burgerMenu>
        <div className="rules-page-wrapper__main--block">
          <div className="rules-page-wrapper__main-info">
            <RulesGame typeRule={typeRule} />
          </div>
          {typeRule !== "common" && (
            <div className="rules-page-wrapper__action">
              <div
                onClick={() => onCheckRules()}
                className="rules-page-wrapper__action__accept"
              >
                <BaseSingleCheckbox
                  checkedValue={isRulesAccepted}
                  onCheckValue={onCheckRules}
                  checkboxStyle="rules-page-wrapper__action__accept__checkbox"
                >
                  <div className="rules-page-wrapper__action__accept__label">
                    {isCurrentUserMale()
                      ? t("rules_game.accept_rule_male")
                      : t("rules_game.accept_rule_female")}
                  </div>
                </BaseSingleCheckbox>
              </div>
              <BaseButton
                disabled={!isRulesAccepted}
                onClick={() => continueGame()}
              >
                {t("close_button")}
              </BaseButton>
            </div>
          )}
        </div>
        {/*{game.type === "PREMIUM" && typeRule === typesOfRulePage.in_game && (*/}
        {/*  <div className="rules-page-wrapper__action">*/}
        {/*    <div*/}
        {/*      onClick={() => onCheckRules()}*/}
        {/*      className="rules-page-wrapper__action__accept"*/}
        {/*    >*/}
        {/*      <BaseSingleCheckbox*/}
        {/*        checkedValue={isRulesAccepted}*/}
        {/*        onCheckValue={onCheckRules}*/}
        {/*        checkboxStyle="rules-page-wrapper__action__accept__checkbox"*/}
        {/*      >*/}
        {/*        <div className="rules-page-wrapper__action__accept__label">*/}
        {/*          {isCurrentUserMale()*/}
        {/*            ? t("rules_game.accept_rule_male")*/}
        {/*            : t("rules_game.accept_rule_female")}*/}
        {/*        </div>*/}
        {/*      </BaseSingleCheckbox>*/}
        {/*    </div>*/}
        {/*    <BaseButton*/}
        {/*      disabled={!isRulesAccepted}*/}
        {/*      onClick={() => continueGame()}*/}
        {/*    >*/}
        {/*      {t("continue")}*/}
        {/*    </BaseButton>*/}
        {/*  </div>*/}
        {/*)}*/}
        {/*{game.type === "DEMO" && (*/}
        {/*  <div className="rules-page-wrapper__buy-btn">*/}
        {/*    <BaseButton onClick={() => navigateTo(ROUTES.PAYMENT_PAGE)}>*/}
        {/*      {t("buyFor29")}*/}
        {/*    </BaseButton>*/}
        {/*  </div>*/}
        {/*)}*/}
      </WrapperPage>
    </div>
  );
}
